<span
  class="eva-badge"
  [class.eva-badge--dot]="dot"
  [class.eva-badge--primary]="severity === 'primary'"
  [class.eva-badge--secondary]="severity === 'secondary'"
  [class.eva-badge--success]="severity === 'success'"
  [class.eva-badge--warning]="severity === 'warning'"
  [class.eva-badge--danger]="severity === 'danger'"
  [class.eva-badge--info]="severity === 'info'"
  [class.eva-badge--small]="size === 'small'"
  [class.eva-badge--medium]="size === 'medium'"
  [class.eva-badge--large]="size === 'large'"
>
  {{ displayValue }}
</span>
